module.exports = function checksumPath (path, checksum) {
  let match = path.match(/^(.+)(\.\w+)$/);
  if (!match) {
    throw new Error(`Cannot add checksum to path without an extension: ${path}`);
  }
  return `${match[1]}-${checksum}${match[2]}`;
};



// WEBPACK FOOTER //
// ./lib/rlink-router/checksumPath.js